export default function initAlert() {
  const alertExpands = document.querySelectorAll(".alert-expand");

  if (!alertExpands.length) return;

  alertExpands.forEach((alert) => {
    const title = alert.querySelector(".alert-expand-title");
    const body = alert.querySelector(".alert-expand-body");
    const toggleText = title?.querySelector("span");

    if (!title || !body) return;

    // Mark as initialized to prevent FOUC
    alert.classList.add("is-initialized");

    // Initialize: if already has is-open, set max-height to none
    if (alert.classList.contains("is-open")) {
      body.style.maxHeight = "none";
    }

    function updateText(isOpen) {
      if (toggleText) {
        toggleText.childNodes.forEach((node) => {
          if (node.nodeType === Node.TEXT_NODE) {
            const text = node.textContent.trim();
            if (text) {
              node.textContent = isOpen
                ? node.textContent.replace("More", "Less")
                : node.textContent.replace("Less", "More");
            }
          }
        });
      }
    }

    function toggleAlert() {
      const isOpen = alert.classList.contains("is-open");

      if (isOpen) {
        // Closing
        body.style.maxHeight = body.scrollHeight + "px";
        // Force reflow
        body.offsetHeight;
        body.style.maxHeight = "0";
        alert.classList.remove("is-open");
        updateText(false);
      } else {
        // Opening
        body.style.maxHeight = "0";
        // Force reflow
        body.offsetHeight;
        alert.classList.add("is-open");
        body.style.maxHeight = body.scrollHeight + "px";
        updateText(true);

        // After transition, set to none to allow dynamic content
        body.addEventListener(
          "transitionend",
          () => {
            if (alert.classList.contains("is-open")) {
              body.style.maxHeight = "none";
            }
          },
          { once: true }
        );
      }
    }

    // Click on alert to toggle
    alert.addEventListener("click", (e) => {
      // Don't close if clicking on links or buttons inside body
      const clickedInBody = body.contains(e.target);
      const isInteractive =
        e.target.closest("a") ||
        e.target.closest("button") ||
        e.target.closest('input[type="button"]') ||
        e.target.closest('input[type="submit"]');

      if (clickedInBody && isInteractive) {
        return;
      }

      toggleAlert();
    });

    // If has is-open class, update text to "Less"
    if (alert.classList.contains("is-open")) {
      updateText(true);
    }
  });
}
